__turbopack_context__.v({
  "accordion": "Accordion-module__NlDMpW__accordion",
  "chevron": "Accordion-module__NlDMpW__chevron",
  "content": "Accordion-module__NlDMpW__content",
  "header": "Accordion-module__NlDMpW__header",
  "item": "Accordion-module__NlDMpW__item",
  "panel": "Accordion-module__NlDMpW__panel",
  "slideDown": "Accordion-module__NlDMpW__slideDown",
  "slideUp": "Accordion-module__NlDMpW__slideUp",
  "trigger": "Accordion-module__NlDMpW__trigger",
});
